export default __webpack_public_path__ + "assets/pdf.1e6c885f.svg";